import styled from 'styled-components';
import Drawer from 'antd/es/drawer';
import Link from 'next/link';

export const StyledDrawer = styled(Drawer)`
  &&& {
    .setur-drawer-header {
      background-color: ${({ theme }) => theme.palette.grey1100};
      padding: 12px 16px;
      min-height: 60px;
      display: flex;
      align-items: center;
      gap: 24px;
    }

    .setur-drawer-header-title {
      flex-direction: row-reverse;
    }
    .setur-drawer-close {
      margin-inline-end: 0px;
      padding: 0px;
    }

    .setur-drawer-body {
      background-color: ${({ theme }) => theme.palette.white};
      padding: 0px;
    }
  }
`;

export const UserBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const UserBadge = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.yellow500};
  color: ${({ theme }) => theme.palette.white};
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UserFullName = styled.div`
  color: ${({ theme }) => theme.palette.white};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 250px;
`;

export const UserMenuLink = styled(Link)`
  padding: 16px 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 56px;
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;

  &:last-child {
    border-top: 1px solid ${({ theme }) => theme.palette.grey300};
  }
`;
